import React, { useCallback, useEffect } from "react";
import { Adapter } from "../../../types/adapter";
import { WizardService } from "../../../services/WizardService";
import { List, Modal, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface SuggestedAdapterListProps {
  sdkId?: number;
  open: boolean;
  onAdapterSelected?: (adapters: Adapter[]) => void;
  onClose?: () => void;
}

export const SuggestedAdapterList = (props: SuggestedAdapterListProps) => {
  const api = WizardService.Sdk;

  const [adapters, setAdapters] = React.useState<Adapter[]>([]);
  const [selected, setSelected] = React.useState<number[]>([]);

  const fetch = useCallback(() => {
    props.sdkId &&
      api.suggestedAdapters(props.sdkId).then((adapters) => {
        setAdapters(adapters);
      });
  }, [api, props.sdkId]);

  useEffect(() => {
    if (props.open) {
      setSelected([]);
      fetch();
    }
  }, [fetch, props.open]);

  const handleOk = () => {
    const result = adapters.filter(
      (adapter) => adapter.id && selected.includes(adapter.id)
    );
    props.onAdapterSelected?.(result);
    props.onClose?.();
  };

  const handleCancel = () => {
    setSelected([]);
    props.onClose?.();
  };

  return (
    <Modal
      open={props.open}
      title="Suggested Adapters"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <List
        dataSource={adapters}
        renderItem={(adapter) => (
          <List.Item
            onClick={() =>
              selected.includes(adapter.id!)
                ? setSelected((current) =>
                    current.filter((id) => id !== adapter.id)
                  )
                : setSelected([...selected, adapter.id!])
            }
          >
            <Text>
              {adapter.status} - {adapter.version}
            </Text>
            {selected.includes(adapter.id!) && (
              <CheckOutlined  />
            )}
          </List.Item>
        )}
      ></List>
    </Modal>
  );
};
